import * as React from 'react';
import CardCarousel from './CardCarousel';
import { ICarousel } from './Carousel.interface';
import { StyledContainer } from './Carousel.styles';

const ResponsiveCarousel: React.FC<ICarousel> = ({
  items,
  isMultiItemCarousel,
  bgColor,
}) => {
  return (
    <StyledContainer className="pt-4 pb-12 lg:px-2 w-full" color={bgColor}>
      {isMultiItemCarousel ? (
        <CardCarousel items={items} />
      ) : (
        <div className="flex items-center justify-center text-white">
          Insert featured resource here
        </div>
      )}
    </StyledContainer>
  );
};

export default ResponsiveCarousel;
